import {
  WS_RESPONSE_MESSAGE_TYPE,
  ChannelTypeEnum,
  MailConversationDataType,
  getPureTextFromHtml,
  SendingStatus,
  MailDataInfo,
  MailContact,
} from "../..";
import {
  MailConversationStatusChangeData,
  MailLoginSuccessData,
  MailUnreadNumUpdateData,
} from "./ws-types";
import chatSdkHooks from "../../hooks";
import { WSResponseData } from "../../request/ws";

const waitingWorks = [] as WSResponseData[];

function handlePushWaitWorks(data: WSResponseData) {
  waitingWorks.push(data);
}

/** 监听接收到的消息 */
function handleReceiveMessage(data: MailDataInfo, from_user_id: string) {
  chatSdkHooks.mail.receiveMessageHook.emit({
    ...data,
    from_user_id,
    sending_status: SendingStatus.SUCCESS,
  });
}

export function wsHandler(data: WSResponseData) {
  if (data.type) {
    handlePushWaitWorks(data);
  }
}

function handleUnreadNumUpdate(data: MailUnreadNumUpdateData) {
  chatSdkHooks.mail.unreadNumUpdateHook.emit(data);
}

/**
 * 处理接收到的最新联系人信息
 */
function handleGetContactDetail(data: MailContact, from_user_id: string) {
  chatSdkHooks.mail.getContactDetailHook.emit({
    ...data,
    from_user_id,
    renderId: `${data.from_user_id}_${data.user_id}`,
  });
}

// @ts-ignore
window.requestIdleCallback =
  window.requestIdleCallback ||
  function (cb) {
    const start = Date.now();
    return setTimeout(function () {
      cb({
        didTimeout: false,
        timeRemaining: function () {
          return Math.max(0, 50 - (Date.now() - start));
        },
      });
    }, 1);
  };

window.cancelIdleCallback =
  window.cancelIdleCallback ||
  function (id) {
    clearTimeout(id);
  };

function handlePopWaitWorks() {
  window.requestIdleCallback(
    () => {
      const work = waitingWorks.shift();
      if (work) {
        const { data, type, user_id } = work;
        switch (type) {
          case WS_RESPONSE_MESSAGE_TYPE.LOGIN_SUCCESS:
            handleLoginSuccess(data as MailLoginSuccessData);
            break;
          case WS_RESPONSE_MESSAGE_TYPE.LOGIN_OUT:
          case WS_RESPONSE_MESSAGE_TYPE.CLIENT_CLOSE: {
            handleLogout(user_id, data?.quit_reason);
            break;
          }
          case WS_RESPONSE_MESSAGE_TYPE.UNREAD_NUM_UPDATE: {
            handleUnreadNumUpdate(data as MailUnreadNumUpdateData);
            break;
          }
          case WS_RESPONSE_MESSAGE_TYPE.CONVERSATION_CHANGE: {
            handleConversationChange(data as MailConversationDataType);
            break;
          }
          case WS_RESPONSE_MESSAGE_TYPE.CONVERSATION_STATUS_CHANGE:
            handleConversationStatusChange(
              data as MailConversationStatusChangeData
            );
            break;
          case WS_RESPONSE_MESSAGE_TYPE.GET_CONTACT_DETAIL: {
            handleGetContactDetail(data as MailContact, user_id);
            break;
          }
          case WS_RESPONSE_MESSAGE_TYPE.RECEIVE_MESSAGE:
          case WS_RESPONSE_MESSAGE_TYPE.OTHER_TERMINAL_RECEIVE_MESSAGE: {
            handleReceiveMessage(data as MailDataInfo, user_id);
            break;
          }
        }
      }
      handlePopWaitWorks();
    },
    { timeout: 100 }
  );
}
handlePopWaitWorks();

/** 登录成功之后将用户信息存放到db */
function handleLoginSuccess(data: MailLoginSuccessData) {
  chatSdkHooks.common.loginSuccessHook.emit({
    channelType: ChannelTypeEnum.Email,
    user_id: data?.user_id,
  });
}

function handleLogout(user_id: string, quit_reason: string = "") {
  chatSdkHooks.common.logoutHook.emit({
    channelType: ChannelTypeEnum.Email,
    user_id,
    quit_reason,
  });
}

/** 处理会话变更 */
function handleConversationChange(data: MailConversationDataType) {
  if (data.last_message) {
    data.last_message.pure_text = getPureTextFromHtml(
      data.last_message.content
    );
  }
  chatSdkHooks.mail.conversationChangeHook.emit(data);
}

function handleConversationStatusChange(
  data: MailConversationStatusChangeData
) {
  // 未读数变化不在这里做处理，在conversationChangeHook已经有通知了
  const effectiveData = {
    ...data,
    data: data?.data
      ?.filter((item) => item?.unread === undefined || item?.unread === null)
      ?.map((item) => {
        Object.entries(item).forEach(([key, value]) => {
          if (value === undefined || value === null) {
            delete item[key as keyof typeof item];
          }
        });
        if (item.last_message) {
          item.last_message.pure_text = getPureTextFromHtml(
            item.last_message.content
          );
        }
        return item;
      }),
  };

  chatSdkHooks.mail.conversationStatusChangeHook.emit(effectiveData);
}
